export enum PayrollStates {
    Open = 'open',
    Processing = 'processing',
    Pending = 'pending',
    Paying = 'paying',
    Paid = 'paid',
    Locked = 'locked',
}
